export class ReceivedMeals {
  constructor(
    public mealDeliveryDateTime: string = '',
    public mealDeliveryTemperature: number = 0.0,  
    public mealCountOrdered: number = 0,
    public mealCountReceived: number = 0,
    public mealCountLeftoverPrevious: number = 0,
    public receivedBy: number = 0,
    public receivedByFirstName: string = '',
    public receivedByLastName: string = '',
    public createdDateTimeUtc: string = '',
    public modifiedDateTimeUtc: string = ''
  ) {
  }
}
